import React, { useState } from "react";
import { Container, Row, Col, Card, Button, Modal } from "react-bootstrap";
import Place from '../assets/place.jpg'
import John from '../assets/male1.jpg'
import Sarah from '../assets/fem1.jpg'
import Michael from '../assets/male2.jpg'
const teamMembers = [
  {
    id: 1,
    name: "John Smith",
    title: "Chief Executive Officer",
    image: John,
    bio: "John Smith has over 20 years of experience leading organizations and developing strategic growth initiatives. He has extensive experience in operations, acquisitions, and building high-performing teams."
  },
  {
    id: 2,
    name: "Sarah Johnson",
    title: "Chief Operating Officer",
    image: Sarah,
    bio: "Sarah Johnson specializes in operational execution, process improvement, and scaling companies through disciplined management practices. She has successfully managed teams across multiple industries."
  },
  {
    id: 3,
    name: "Michael Williams",
    title: "Chief Financial Officer",
    image: Michael,
    bio: "Michael Williams brings extensive financial leadership experience including capital strategy, financial planning, acquisitions, and investor relations."
  }
];


function ManagementTeam() {

  const [selectedMember, setSelectedMember] = useState(null);

  const handleClose = () => setSelectedMember(null);

  return (
    
    <section id="management-team" style={{paddingTop:'35px',backgroundColor:'black'}}>
      <Container>
  <div class="section-label" style={{color:'white'}}>Leadership</div>
    <h2 class="section-title" style={{color:'white'}}>Management Team</h2>
    <div class="divider-gold"></div>
              <p style={{ fontSize: '.9rem', color: 'white', maxWidth: '560px', marginBottom: '48px', lineHeight: 1.8 }}>
    Built by Experience. Driven by Innovation.
    </p>
        {/* <Row className="g-4 justify-content-center">

          {teamMembers.map((member) => (

            <Col key={member.id} lg={4} md={6}>

              <Card className="management-card h-100 text-center" style={{backgroundColor:'transparent', color:'white', border:' 2px solid white'}}>

                <Card.Body>

                  <img
                    src={member.image}
                    alt={member.name}
                    className="rounded-circle mb-4"
                    style={{
                      width: "150px",
                      height: "150px",
                        objectFit: "cover"
                      
                    }}
                  />


                  <Card.Title
                    className="fw-bold"
                  >
                    {member.name}
                  </Card.Title>


                  <Card.Subtitle
                    className="mb-4 "
                  >
                    {member.title}
                  </Card.Subtitle>


                  <Button style={{backgroundColor:'var(--gold)', color:'white', border:'none'}}
                    variant=""
                    onClick={() => setSelectedMember(member)}
                  >
                    Read Bio
                  </Button>


                </Card.Body>

              </Card>

            </Col>

          ))}

        </Row> */}


        {/* Bio Modal */}

        {/* <Modal
          show={selectedMember !== null}
          onHide={handleClose}
          centered
        >

          <Modal.Header closeButton>

            <Modal.Title>
              {selectedMember?.name}
            </Modal.Title>

          </Modal.Header>


          <Modal.Body> */}

            {/* <div className="text-center mb-3">

              <img
                src={selectedMember?.image}
                alt={selectedMember?.name}
                className="rounded-circle"
                style={{
                  width: "120px",
                  height: "120px",
                  objectFit: "cover"
                }}
              />

            </div> */}


            {/* <h6 className="text-center">
              {selectedMember?.title}
            </h6> */}


            {/* <p className="mt-3">
              {selectedMember?.bio}
            </p>

          </Modal.Body> */}


          {/* <Modal.Footer>

            <Button
              variant="secondary"
              onClick={handleClose}
            >
              Close
            </Button>

          </Modal.Footer> */}

        {/* </Modal> */}
            <div className='row align-items-center'>
                <div className='col-12 col-lg-6 my-3 text-center'>
                    <img src={John}/>
                </div>
                <div className='col-12 col-lg-6 my-3 biocards text-center' style={{padding:'0px 125px'}}>
                    <h2 className='fw-bold text-white'>John Smith</h2>
                    <h5 style={{ color: 'var(--gold)' }}>Chief Executive Officer</h5>
                    <h6 className="text-white">John Smith has over 20 years of experience leading organizations and developing strategic growth initiatives. He has extensive experience in operations, acquisitions, and building high-performing teams.</h6>
                    </div>
            </div>
                <div className='row align-items-center'>
                      <div className='col-12 col-lg-6 my-3 text-center order-1 order-lg-2'>
                    <img src={Sarah}/>
                </div>
                 <div className='col-12 col-lg-6 my-3 biocards text-center order-2 order-lg-1' style={{padding:'0px 125px'}}>
                    <h2 className='fw-bold text-white'>Sarah Johnson</h2>
                    <h5 style={{ color: 'var(--gold)' }}>Chief Operating Officer</h5>
                    <h6 className="text-white">Sarah Johnson specializes in operational execution, process improvement, and scaling companies through disciplined management practices. She has successfully managed teams across multiple industries.</h6>
                    </div>
              
               
            </div>
             <div className='row align-items-center'>
                <div className='col-12 col-lg-6 my-3 text-center'>
                    <img src={Michael}/>
                </div>
                <div className='col-12 col-lg-6 my-3 biocards text-center' style={{padding:'0px 125px'}}>
                    <h2 className='fw-bold text-white'>Michael Williams</h2>
                    <h5 style={{ color: 'var(--gold)' }}>Chief Financial Officer</h5>
                    <h6 className="text-white">Michael Williams brings extensive financial leadership experience including capital strategy, financial planning, acquisitions, and investor relations.</h6>
                    </div>
</div>
      </Container>
    </section>
  );
}

export default ManagementTeam;